module.exports = __webpack_public_path__ + "static/img/logistics2.c77e8f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/logistics2.png
// module id = tmfv
// module chunks = 2